import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-news-selector-filter',
  templateUrl: './news-selector-filter.component.html',
  styleUrls: ['./news-selector-filter.component.scss']
})
export class NewsSelectorFilterComponent{

  /**
   * Output event for set the category of articles when some is clicked.
   *
   * @memberof NewsSelectorFilterComponent
   */
  @Output() selectionChange = new EventEmitter<string>();
  /**
   * The array of tags used in news.
   *
   * @memberof NewsSelectorFilterComponent
   */
  tags: Array<{name:string, value:string}> = [{
    name: 'All', value:null
  },
  {
    name: 'News', value:'news'
  },
  {
    name: 'Features', value:'feature'
  },
  {
    name: 'Press releases', value:'press_release'
  },
  {
    name: 'Archive', value:'archive'
  }

]

  /**
   * Method for set the select change and emit the event.
   *
   * @param {string} [type]
   * @memberof NewsSelectorFilterComponent
   */
  selectChange(type?:string) {
    this.selectionChange.emit(type);
  }

}
